import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PRODUCTS } from 'src/app/shared/constants/common-constants';
import { CommonService } from 'src/app/shared/services/angular-service/common.services';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { SeoService } from 'src/app/shared/services/angular-service/seo.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';

@Component({
  selector: 'app-industry-report-page',
  templateUrl: './industry-report-page.component.html',
  styleUrls: ['./industry-report-page.component.scss']
})
export class IndustryReportPageComponent implements OnInit {
  companyOverview: any;
  productList: any;
  isAddedInFollowList: any;
  cin:string;
  productType : any;
  company_name : string;
  PRODUCTS = PRODUCTS
  deviceType;

  constructor(
    private companyService: CompanyService,
    private route: ActivatedRoute,
    private localStorage:LocalStorageService,
    private router: Router,
    private toastService: ToastService,
    private commonService:CommonService,
    private seoService: SeoService
  ) {
    this.route.params.subscribe(
      (params) => {
        this.company_name = params.name;
        let product_name = params.report;
        this.cin = this.localStorage.getItem(this.company_name);
        this.productType = PRODUCTS[product_name.toUpperCase()];
      }
    );

    this.deviceType = localStorage.getItem('deviceType');
  }

  ngOnInit(): void {
    this.seoService.getSeo('report');
    this.companyService.sharedData$.subscribe((data) => {
      if (data) {
        this.companyOverview = data;
        this.productList = data.product_list;
        this.isAddedInFollowList = this.commonService.isInFollowlist(
          this.companyOverview._id
        );
      }else{
        this.getCompanyByUrl(this.company_name)
      }
    });
  }

  getCompanyByUrl(url) {
    let request = '?companyUrl=' + url;
    this.companyService
      .getCompanyDetail(request)
      .then((data: any) => {
        if (data != null && data != undefined) {
          this.cin = data.cin;
          this.localStorage.setItem(this.company_name, this.cin);
          this.getHistoricalData();
        } else {
          this.router.navigateByUrl('/404');
        }
      })
      .catch((err: any) => {
        this.router.navigateByUrl('/404');
      });
  }

  getHistoricalData() {
    let request = { cin: this.cin };
    this.companyService
      .getCompanyHistoricalDetails(request)
      .then((data: any) => {
        if (data.message) {
          this.toastService.addSingle('error', 'Error', data.message);
          this.router.navigate(['/company']);
        } else {
          this.companyOverview = data;
          let initialValue = {};
          this.companyOverview['roc_product_list'] = this.companyOverview.product_list_arr.filter(
            (item) => item.type === 'ROC'
          );
          this.companyOverview['pls_product_list'] = this.companyOverview.product_list_arr.filter(
            (item) => item.type === 'PLS'
          );
          this.companyOverview['bss_product_list'] = this.companyOverview.product_list_arr.filter(
            (item) => item.type === 'BSS'
          );
          this.companyOverview.product_list = this.companyOverview.product_list_arr.filter(
            (item) =>
              item.type !== 'BSS' && item.type !== 'ROC' && item.type !== 'PLS'
          );

          this.companyOverview.product_list = this.companyOverview.product_list.reduce(
            (obj, item) => {
              return {
                ...obj,
                [item['type']]: item,
              };
            },
            initialValue
          );
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  }


  // getSeo(tab) {
  //   let seosData = {
  //     compnayName: this.company_name,
  //   };
  // }

}
